<template>
<div class="container-fluid">
    <div class="card animated fadeIn">
        <!-- <pre>system {{config.snippet}} </pre> -->
        <b-row>
            <b-col sm=12>
                <b-card border-variant="light">
                    <div slot="header">
                        <strong>System:</strong>
                        <!--   <pre>Data: {{$data}}</pre><pre>changed: {{changed}}</pre>  -->
                    </div>
                    <div>
                        <b-form @submit.stop.prevent="onSubmit">
                            <!--                 <b-form-group label="Device Name:" label-for="config_name">
                  <b-form-text>Default:</b-form-text>
                  <b-form-input type="text" v-model="config.name" v-validate.initial="''" id="config_name" name="config Name" class="form-control" :class="{'is-invalid': submitted && verrors.has('config Name') }"></b-form-input>
                  <div v-if="submitted && verrors.has('config Name')" class="invalid-feedback">{{ errors.first('config Name') }}</div>    
                </b-form-group> -->
                            <b-form-group label-for="config_hostname">
                                <template v-slot:label>
                                    DHCP Client Hostname:
                                </template>
                                <b-form-input v-model="config.snippet.system.system[0].hostname" v-validate.initial="''" id="config_hostname" name="Hostname" class="form-control" :class="{'is-invalid': submitted && verrors.has('Hostname') }" :placeholder="config.snippet.system.system[0].hostname" :disabled=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('Hostname')" class="invalid-feedback">{{ errors.first('Hostname') }}</div>
                            </b-form-group>
                            <!--                 <b-form-group label="config Password:" label-for="config_pass">
                  <b-form-input type="text" v-model="config.name" v-validate.initial="''" id="config_pass" name="config Password" class="form-control" :class="{'is-invalid': submitted && verrors.has('config Password') }"    
                  :append-icon="value ? 'visibility' : 'visibility_off'" 
                  @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'"
                  ></b-form-input>
                  <div v-if="submitted && verrors.has('config Password')" class="invalid-feedback">{{ errors.first('config Password') }}</div>
                </b-form-group> -->
                            <div class="text-center">
                                <!-- TODO only activate when dirty -->
                                <button v-if="readonly" :disabled="verrors.any()" class="btn btn-primary">Add</button>
                                <!--  <b-button type="reset" variant="danger">Reset</b-button> -->
                                <!-- <button @click.prevent="reRender">Reset</button> -->
                            </div>
                        </b-form>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import Tasks from "@/readynet/configs/network/Tasks";

export default {
    components: {
        ValidationProvider,
        Multiselect,
        Tasks,
    },
    props: {
        config: {},

        changed: {
            type: Array,
        },
        changes: {
            type: Object,
        },
    },
    data() {
        return {
            loading: false,
            submitted: false,

        }
    },
    methods: {
        mounted() {},
        updateChanged(par, val, nam) {
            for (var i = this.changed.length - 1; i >= 0; i--) {
                if (this.changed[i].param === par) {
                    this.changed.splice(i, 1);
                }
            }
            this.changed.push({ param: par, value: val, name: nam })
            this.$set(this.changes, par, val)
        },
        onSubmit() {
            this.submitted = true;
            // console.log("Invalid " + (this.$validator.fields).map(field => field.flags.invalid))
            // console.log("Dirty " + (this.$validator.fields).map(field => field.flags.dirty))
            // console.log("IP dirty " + this.veeFields['LAN IP'].dirty);
            // console.log("netmask dirty " + this.veeFields['LAN Netmask'].dirty);

            // Object.keys(this.veeFields).every(field => {
            //   if (this.veeFields[field].dirty) {
            //     console.log("MSG:", this.veeFields[field] + " ", field)

            //   }
            // });

            this.$validator.validate().then(valid => {

                if (valid) {
                    // need to simplify this
                    // if (this.veeFields['config Name'].dirty) {
                    //   this.updateChanged("config_name", this.config.name, "config Name")
                    // }
                    if (this.veeFields['Hostname'].dirty) {
                        this.updateChanged("config_hostname", this.config.snippet.system.system[0].hostname, "Hostname")
                    }

                    // this.$router.push("/#/configs");
                } else {
                    console.log("LAN submitted, INVALID");
                }
            });
        },

    }, // end methods
    computed: {
        readonly() {
            return this.$can('config','edit')
        },
    }
};
</script>
// isFormValid () { // // loop over all contents of the fields object and check if they exist and valid or valid == null. // return Object.keys(this.veeFields).every(field => { // return this.veeFields[field] && (this.veeFields[field].valid || (this.veeFields[field].valid == null)); // }); // } // toArray(obj_obj) { // return Object.keys(obj_obj).map(i => obj_obj[i]); // }, // computed:{ // local: { // get() { // return this.params // }, // set(val) { // // this.$emit('input', val) // } // }, // }, // watch:{ // params:{ // // deep: true, // handler(){ // this.my = this.params // } // }, // },
